import React, { useState } from "react";
import { updateUserPassword } from "../../../../api/users";
import { log_error } from "../../../../api";
import { ReactComponent as Visible } from "../../../../public/visible.svg";
import { ReactComponent as Invisible } from "../../../../public/invisible.svg";
import { Link } from "react-router-dom";

export default ({ user }) => {
  const [successUpdate, setSuccessUpdate] = useState(false);
  const [errors, setErrors] = useState(null);
  const [state, setState] = useState({
    password: "",
    new_password: "",
    confirm_password: "",
  });
  const [visible, setVisible] = useState({
    password: false,
    new_password: false,
    confirm_password: false,
  });
  const togglePasswordVisibility = (name) => setVisible({ ...visible, [name]: !visible[name] });
  const onSubmit = async (e) => {
    e.preventDefault();
    try {
      setErrors(null);
      const { password, new_password, confirm_password } = state;
      if (new_password !== confirm_password) {
        setErrors([
          {
            message: "Password does not match.",
          },
        ]);
        return false;
      }
      if (new_password === password) {
        setErrors([
          {
            message: "New password must be different from existing password.",
          },
        ]);
        return false;
      }
      await updateUserPassword({
        old_password: password,
        new_password: new_password,
        confirm_new_password: confirm_password,
        remember_me: !sessionStorage.getItem("Authorization"),
      });
      setSuccessUpdate(true);
    } catch (error) {
      setErrors(log_error(error));
    }
  };
  const updateForm = (e) => {
    const { name, value } = e.target;
    setState({ ...state, [name]: value });
  };
  return (
    <div id="account-settings">
      {errors
        ? errors.map((e) => <div className="alert alert-danger">{e.message}</div>)
        : successUpdate && <div className="alert alert-success">Password changed successfully</div>}
      <form onSubmit={onSubmit}>
        <div className="form-group position-relative">
          <div className="form-row mb-3">
            <div className="col-100 col-md-35 d-flex align-items-center">
              <label className="m-0">Your Current Password</label>
            </div>
            <div className="col-100 col-md-65">
              <input
                className="form-control password-field"
                id="oldpassword"
                name="password"
                placeholder="Enter Your Current Password"
                onChange={updateForm}
                type={visible.password ? "text" : "password"}
              />
              {visible.password ? (
                <Visible className="passwordVisibility" onClick={() => togglePasswordVisibility("password")} />
              ) : (
                <Invisible className="passwordVisibility" onClick={() => togglePasswordVisibility("password")} />
              )}
            </div>
          </div>
        </div>

        <div className="form-group position-relative">
          <div className="form-row mb-3">
            <div className="col-100 col-md-35 d-flex align-items-center">
              <label className="m-0">Your New Password</label>
            </div>
            <div className="col-100 col-md-65">
              <input
                className="form-control password-field"
                id="newpassword"
                name="new_password"
                placeholder="Enter Your New Password"
                onChange={updateForm}
                type={visible.new_password ? "text" : "password"}
              />
              {visible.new_password ? (
                <Visible className="passwordVisibility" onClick={() => togglePasswordVisibility("new_password")} />
              ) : (
                <Invisible className="passwordVisibility" onClick={() => togglePasswordVisibility("new_password")} />
              )}
              <small className="form-control-feedback text-light">
                Password must be at least 8 characters long, and include one uppercase letter, one lowercase letter, and one number (0-9)
              </small>
            </div>
          </div>
        </div>

        <div className="form-group position-relative">
          <div className="form-row mb-3">
            <div className="col-100 col-md-35 d-flex align-items-center">
              <label className="m-0">Confirm Your New Password</label>
            </div>
            <div className="col-100 col-md-65">
              <input
                className="form-control password-field"
                id="newpasswordconfirm"
                name="confirm_password"
                placeholder="Confirm Your New Password"
                onChange={updateForm}
                type={visible.confirm_password ? "text" : "password"}
              />
              {visible.confirm_password ? (
                <Visible className="passwordVisibility" onClick={() => togglePasswordVisibility("confirm_password")} />
              ) : (
                <Invisible className="passwordVisibility" onClick={() => togglePasswordVisibility("confirm_password")} />
              )}
            </div>
          </div>
        </div>
        <div className="form-row d-flex justify-content-center mt-5">
          <Link to="/">
            <button type="reset" className="submit btn btn-outline-primary mr-3">
              Cancel
            </button>
          </Link>
          <button type="submit" className="submit btn btn-primary ml-3">
            Save
          </button>
        </div>
      </form>
    </div>
  );
};
